import { SDBaseService } from 'app/n-services/SDBaseService';
//CORE_REFERENCE_IMPORTS
import { httpInterceptorProviders } from 'app/http-interceptors';


export const sdProviders = [
SDBaseService,
 //CORE_REFERENCE_PUSH_TO_SD_ARRAY
    httpInterceptorProviders
];
